const INVOICEAPI = {
  GETALLINVOICE: `invoice/clients/invoice/all`,
  POSTALLINVOICE: `invoice/outward`,
  // POSTALLINVOICE: (data)=>`invoice/outward/${data}`,
  POSTBULKINVOICE: `invoice/outward/`
};

export default INVOICEAPI;
